import { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import { setTrustThisBrowser, trustThisBrowser } from "../auth/trustedBrowser";

/**
 * "Trust this browser" on the second-step screens (owner 2026-10-25). On by
 * default; turning it off forgets what this browser remembered. radaccess
 * decides how long a trust lasts: 7 days for Owner, Admin and Billing, 30 for
 * other staff.
 */
export function TrustBrowserChoice() {
  const [on, setOn] = useState(trustThisBrowser);
  return (
    <FormControlLabel
      sx={{ mt: 1 }}
      control={
        <Checkbox
          checked={on}
          onChange={(e) => {
            setOn(e.target.checked);
            setTrustThisBrowser(e.target.checked);
          }}
          slotProps={{ input: { "aria-label": "Trust this browser", "data-testid": "trust-browser" } as object }}
        />
      }
      label={
        <Typography variant="body2">
          Trust this browser: skip this extra step here for up to 30 days (7 for Owner, Admin and Billing). Not on a shared computer.
        </Typography>
      }
    />
  );
}
